import {uniqueId} from 'lodash';
import React, {useCallback, useState} from 'react';
import {useEventConnections} from '../../../../../../../data/hooks/connections/useEventConnections';
import {useLocalI18n} from '../../../../../../../data/hooks/i18nHooks';
import strings from '../../BubblesFilter.i18n.csv';
import styles from '../../BubblesFilter.module.scss';
import FilterButton from '../../FilterButton';
import icon from './icon-innercircle-white.png';

const InnerCircleFilter = props => {
    const {event, filterParams, onFilterActivation} = props,
        i18n = useLocalI18n(strings),
        eventConnections = useEventConnections(event.id),
        visible = !!eventConnections.length,
        [filterId] = useState(uniqueId('inner-circle-filter-'));

    const handleClick = useCallback(() => {
        app.store.dispatch(
            app.actions.participants.setFilterParams(event.id, {
                ...(filterParams || {}),
                connections: filterParams?.connections ? null : {},
            })
        );
    }, [filterParams]);

    const handleMouseOver = useCallback(() => onFilterActivation(filterId), [onFilterActivation]);

    if (!visible) return null;

    return (
        <FilterButton
            className={styles.innercircle}
            event={event}
            active={filterParams?.connections}
            icon={icon}
            onClick={handleClick}
            onMouseOver={handleMouseOver}>
            {i18n['inner-circle']}
        </FilterButton>
    );
};

export default InnerCircleFilter;
